import React from "react";
import { useIonRouter, IonIcon, IonButton } from "@ionic/react";
import {
  chatbubble,
  chatbubbleEllipses,
  chatbubbleOutline,
} from "ionicons/icons";
import formatCount from "../../utils/formatCount";
const ReplyBtn = ({ replies, id }) => {
  const router = useIonRouter();

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <IonButton
        fill="clear"
        size="small"
        shape="round"
        className="sidebar-icon display-flex align-items-c post-btns__btn post-btns__reply no-padding-btn"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          router.push(`/post/${id}`);
        }}
      >
        <IonIcon
          icon={chatbubbleEllipses}
          style={{
            width: "30px",
            height: "30px",
            color: "rgba(255, 255, 255, 0.9)",
          }}
        />
      </IonButton>
      <p>{formatCount(replies)}</p>
    </div>
  );
};

export default ReplyBtn;
